<template>
  <div v-if="!loading" class="comment">
    <van-nav-bar title="评价"/>
    <div class="comment-container">
      <div class="comment-list" v-for="item in list" :key="item.id">
        <span class="comment-list-left">{{item.name}}</span>
        <van-rate
          :readonly="status"
          v-model="item.value"
          size="20"
          @change="handleChange(item)"
          color="#ffd21e"
          void-icon="star"
          void-color="#eee"
        />
        <span v-if="item.value === 1" class="comment-list-right">非常差</span>
        <span v-else-if="item.value === 2" class="comment-list-right">较差</span>
        <span v-else-if="item.value === 3" class="comment-list-right">一般</span>
        <span v-else-if="item.value ===4" class="comment-list-right">好</span>
        <span v-else-if="item.value === 5" class="comment-list-right">非常好</span>
        <span v-else class="comment-list-right"></span>
      </div>
    </div>
    <div class="comment-button" v-if="!status">
      <van-button color="#846FFE" block round @click="handlePublish">确定</van-button>
    </div>
  </div>
  <div v-else style="height:100vh;display:flex;align-items: center;justify-content: center;">
    <van-loading size="60px" type="spinner" color="#846ffe" vertical >加载中...</van-loading>
  </div>
</template>

<script>
import { Notify } from 'vant';
import { mapState } from "vuex";
import {commentConfig,publish} from '../../api/comment'
import {commentDetail} from '../../api/searchFoods'
export default {
  name: "Comment",
  data() {
    return {
      loading: true, // 是否加载中
      list: [], // 食谱评论配置列表
      recipeId: '', // 食谱id
      status: false, // 是否是可读状态
      tenantId: '',
    };
  },
  computed: {
    ...mapState(['openId']),
  },
  created(){
    const tenantObj = JSON.parse(localStorage.getItem('teantObj'))
    if(tenantObj){
      this.tenantId = tenantObj.tenantId
    }
    this.recipeId = this.$route.query.id
  },
  mounted(){
    this.getCommentConfig(this.tenantId)
    this.getCommentDetail()
  },
  methods: {
    //返回
    // onClickLeft() {
    //   this.$router.push({ path: "/home" });
    // },
    // 获取评论配置项
    async getCommentConfig(id){
      const res = await commentConfig(id)
      if(res.data.code === 200){
        this.list = res.data.data
      }
    },
    // 点击星星
    handleChange(item){
      const arr = this.list.slice()
      arr.forEach(ele=>{
        if(ele.id == item.id){
          ele.value = item.value
        }
      })
      this.list = arr
    },
    // 发布评价
    handlePublish(){
      const result = this.list.slice()
      const arr = []
      const status = result.every(ele=>ele.value !== undefined? true : false)
      if(status){
        result.forEach(ele=>{
          arr.push({
            star: ele.value,
            scoreIndexId: ele.id
          })
        })
        const data ={
          wchatOpenId: this.openId,
          recipeId: this.recipeId,
          remark: '',
          recipeCommentScoreIndices: arr
        }
        publish(data).then(res=>{
          if(res.data.code === 200){
            this.$router.push({ path: "/home" });
          }
        })
      } else {
        Notify({type: 'warning',message:'还有未评价选项喔!'})
      }
    },
    // 查看评论
    async getCommentDetail(){
      const data = {
        openId:this.openId,
        recipeId:this.recipeId
      }
      const res = await commentDetail(data)
      if(res.data.code === 200){
        this.loading = false
        if(res.data.data && res.data.data.length>0){
          this.status = true
          const arr = this.list.slice()
          arr.forEach(ele=>{
            res.data.data.forEach(item=>{
              if(ele.id === item.scoreId){
                ele.value = item.star
              }
            })
          })
          this.list = [...arr]
        } else {
          this.status = false
        }
      }
    }
  },
};
</script>

<style scoped>
.comment {
}

.comment-container {
  padding: 0.4rem 0.4rem;
}

.comment-list {
  display: flex;
  align-items: center;
  margin: 0.4rem 0;
  justify-content: space-between;
}

.comment-list-left {
  margin-right: 0.3rem;
  width: 2.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.comment-list-right {
  margin-left: 0.3rem;
  width: 1rem;
  text-align: right;
  color:rgba(0, 0, 0, 0.6)
}

/*  发布按钮*/
.comment-button {
  padding: 0 0.4rem;
}
.comment-button .van-button__text {
  margin-left: 0.2rem;
  font-size: 0.3rem;
  letter-spacing: 0.2rem;
}
</style>